import { render } from "./taskmanagement.html?vue&type=template&id=67a7e384&scoped=true&external"
import script from "./taskmanagement.ts?vue&type=script&lang=js&external"
export * from "./taskmanagement.ts?vue&type=script&lang=js&external"

import "./taskmanagement.scss?vue&type=style&index=0&id=67a7e384&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a7e384"],['__file',"src/view/task/taskmanagement/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67a7e384"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67a7e384', __exports__)) {
    api.reload('67a7e384', __exports__)
  }
  
  module.hot.accept("./taskmanagement.html?vue&type=template&id=67a7e384&scoped=true&external", () => {
    api.rerender('67a7e384', render)
  })

}


export default __exports__